export default __webpack_public_path__ + "static/media/logo.3fbc2506.svg";